export enum VEHICLE_ICON {
    Early = 'vehicle-red-animated',
    Late_level1 = 'vehicle-yellow',
    Late_level2 = 'vehicle-orange',
    Late_level3 = 'vehicle-pink',
    OnTime = 'vehicle-green',
    OnTomLayovr = 'vehicle-blue',
    Default = 'vehicle-gray',
}

export enum VEHICLE_COLOR_RGB {
    Green = 'rgb(132, 221, 110)',
    Red = 'rgb(255, 93, 114)',
    Yellow = 'rgb(255, 222, 73)',
    Orange = 'rgb(255, 154, 90)',
    Pink = 'rgb(254, 129, 229)',
    Gray = 'rgb(86, 86, 86)',
    Blue = 'rgb(78, 148, 251)',
}
